<div class="modal-content">
    <div class="modal-header fw-bold">
        <h5 class="modal-title">{{'study-editor.study-dataset.import-study-map.title' | translate}}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="isSaving"></button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <a class="d-block text-decoration-none" data-bs-toggle="collapse" href="#advancedOptions" role="button"
               aria-expanded="false" aria-controls="advancedOptions">
                <i class="fas fa-chevron-down me-2"></i><span translate="study-editor.study-dataset.import-study-map.advanced-options"></span>
            </a>
            <div class="collapse" id="advancedOptions">
                <div class="card card-body bg-light mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="maintainHeaders"
                               [(ngModel)]="maintainHeaders">
                        <label class="form-check-label" for="maintainHeaders" translate="study-editor.study-dataset.import-study-map.maintain-naming">
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Unmapped Items -->
            <div class="col-md-5">
                <div class="card">
                    <div class="card-header bg-danger bg-opacity-25 text-danger fw-bold d-flex justify-content-between align-items-center">
                        <span>{{'Un-Mapped' | uppercase}}</span>
                        <span class="badge rounded-pill bg-secondary">{{ unmappedItems.length }}</span>
                    </div>
                    <div class="card-body p-0 scrollable-container custom-scroll-style">
                        <div
                                cdkDropList
                                #unmappedList="cdkDropList"
                                [cdkDropListData]="unmappedItems"
                                [cdkDropListConnectedTo]="[variateGroupList]"
                                id="unmapped"
                                class="list-group list-group-flush drag-container"
                                (cdkDropListDropped)="drop($event)">
                            <div
                                    class="list-group-item"
                                    *ngFor="let item of unmappedItems"
                                    cdkDrag>
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Variate Group -->
            <div class="col-md-7">
                <div class="card">
                    <div class="card-header bg-card-header bg-opacity-25 d-flex justify-content-between align-items-center">
                 <span class="fw-bold">
                <i class="fas fa-chevron-down me-1"></i>
                    {{ groupName | uppercase}}
                </span>
                        <span class="badge rounded-pill bg-secondary">{{ mapItems.length }}</span>
                    </div>
                    <div class="card-body p-0 scrollable-container custom-scroll-style">
                        <div
                                cdkDropList
                                #variateGroupList="cdkDropList"
                                [cdkDropListData]="mapItems"
                                [cdkDropListConnectedTo]="[unmappedList]"
                                id="mapped-group"
                                class="drag-container"
                                (cdkDropListDropped)="drop($event)">
                            <div class="list-group list-group-flush">
                                <div
                                        *ngFor="let item of mapItems"
                                        cdkDrag
                                        class="list-group-item p-2">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <div class="flex-grow-1">
                                            <div class="fw-bold mb-1">{{ item.name }} <i
                                                    class="fas fa-arrow-right m-2"></i> {{ item.variable?.name }}
                                            </div>
                                            <div class="row text-muted small">
                                                <div class="col-md-4">
                                                    <strong>{{'ontology.variable-details.details.property' | translate}}</strong> {{ item?.variable?.property?.name }}
                                                </div>
                                                <div class="col-md-4">
                                                    <strong>{{'ontology.variable-details.details.scale' | translate}}</strong> {{ item?.variable?.scale?.name }}
                                                </div>
                                                <div class="col-md-4">
                                                    <strong>{{'ontology.variable-details.details.method' | translate}}</strong> {{ item?.variable?.method?.name }}
                                                </div>
                                            </div>
                                        </div>
                                        @if (item.variable) {
                                            <button class="btn btn-sm btn-info" (click)="remapItem(item)">
                                                <i class="fas fa-pencil-alt me-1"></i><span translate="study-editor.study-dataset.import-study-map.re-map"></span>
                                            </button>
                                        } @else {
                                            <button class="btn btn-sm btn-info" (click)="remapItem(item)">
                                                <i class="fas fa-pencil-alt me-1"></i><span translate="study-editor.study-dataset.import-study-map.apply-mapping"></span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row mb-3">
            <div class="col d-flex justify-content-end">
                <button class="btn btn-primary" [disabled]="isSaving" (click)="saveMapping()">
                    <span *ngIf="isSaving" class="throbber throbber-btn"></span>
                    <i class="fas fa-upload me-2"></i><span>{{'study-editor.study-dataset.import-study-map.save-mapping' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
